module.exports = __webpack_public_path__ + "static/img/d45ef7ebc5ba2285(1).343c79cf.png";